"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteTransaction = void 0;
const index_js_1 = require("../../../entity/actions/parse/index.js");
const index_js_2 = require("../../../errors/index.js");
const transaction_js_1 = require("../transactWrite/transaction.js");
const constants_js_1 = require("./constants.js");
const options_js_1 = require("./options.js");
class DeleteTransaction extends transaction_js_1.WriteTransaction {
    constructor(entity, key, options = {}) {
        super(entity);
        this[constants_js_1.$key] = key;
        this[constants_js_1.$options] = options;
    }
    key(nextKey) {
        return new DeleteTransaction(this.entity, nextKey, this[constants_js_1.$options]);
    }
    options(nextOptions) {
        return new DeleteTransaction(this.entity, this[constants_js_1.$key], nextOptions);
    }
    params() {
        var _a;
        if (!this[constants_js_1.$key]) {
            throw new index_js_2.DynamoDBToolboxError('actions.incompleteAction', {
                message: 'DeleteTransaction incomplete: Missing "key" property'
            });
        }
        const options = this[constants_js_1.$options];
        const { key } = this.entity.build(index_js_1.EntityParser).parse(this[constants_js_1.$key], { mode: 'key' });
        const awsOptions = (0, options_js_1.parseOptions)(this.entity, options);
        return {
            Delete: {
                TableName: (_a = options.tableName) !== null && _a !== void 0 ? _a : this.entity.table.getName(),
                Key: key,
                ...awsOptions
            }
        };
    }
}
exports.DeleteTransaction = DeleteTransaction;
DeleteTransaction.actionName = 'transactDelete';
